import React, { useEffect } from 'react';
import { Outlet, useOutletContext, useLocation, useOutlet, matchPath } from 'react-router-dom';
import FashionPcp from '../FashionPcp/index';
import FashionPcpBoard from '../FashionPcpBoard/index';
import { ProductionFashionOutletType } from '..';

const PCPDashboard: React.FC = () => {
    const { pcpView } = useOutletContext<ProductionFashionOutletType>();
    const location = useLocation();
    const outlet = useOutlet();

    const isCreateRoute = location.pathname.includes('/pcp/create');

    console.log('🎯 PCPDashboard renderizado');
    console.log('📍 Pathname:', location.pathname);
    console.log('🔍 isCreateRoute:', isCreateRoute);
    console.log('🔌 outlet existe:', !!outlet);

    if (isCreateRoute && outlet) {
        console.log('✅ Renderizando Outlet (AddFashionOP)');
        return <Outlet />;
    }

    console.log('📊 Renderizando visualização:', pcpView);
    return (
        <>
            {pcpView === 'table' ? (
                <FashionPcp />
            ) : (
                <FashionPcpBoard />
            )}
        </>
    );
};

export default PCPDashboard;